import { defineStore } from 'pinia'

export const useFilterStore = defineStore('FilterStore', {
    state: () => {
        return {
          orders: {},
          invoices: {}
        }
      }
});